import Vue from 'vue'
import Router from 'vue-router'
import ColumnTypes from './views/ColumnTypes'
import ShoppingCart from './views/ShoppingCart'
import ProjectSettingsDialog from './components/ProjectSettingsDialog'
import ModulePlacements from './views/ModulePlacements'
import Summary from './views/Summary'
import JibCrane from './views/JibCrane'
import Configuration from './views/Configuration'
import ElectricalProtection from './views/ElectricalProtection'
import ProjectList from './views/ProjectList'
import ProjectCreateDialog from './views/ProjectCreateDialog'
import { store } from './store'
import { cloak } from './keecloak'
import ProjectHeader from './views/HeaderProjects.vue'
import ErrorView from './views/Error.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'ProjectList',
      components: {
        app: ProjectList,
      },
    },
    {
      path: '/projectCreateDialog',
      name: 'projectCreateDialog',
      components: {
        app: ProjectCreateDialog,
      },
    },
    {
      path: '/unauthorized',
      name: 'unauthorized',
      component: Vue.extend({
        render(h) {
          return h(
            'div',
            { style: { margin: '20px 0' } },
            this.$t('unauthorized')
          )
        },
      }),
    },
    {
      path: '/#edit',
      name: 'projectSettingsDialog',
      component: ProjectSettingsDialog,
    },
    {
      path: '/projects/:projectId',
      name: 'shoppingCart',
      components: {
        app: ShoppingCart,
        header: ProjectHeader,
      },
      beforeEnter: async (to, from, next) => {
        await Promise.all([
          store.dispatch('loadModules'),
          store.dispatch('loadColumnTypes'),
          store.dispatch('projects/loadProject', to.params.projectId),
        ])
        store.commit('configurations/clearActiveConfiguration')
        await store.dispatch('configurations/loadConfigurations')
        next()

        // TODO: Das und der Watcher im Store auf die Amounts ist nicht ganz so optimal
        store.dispatch("projects/generateBom")
      }
    },
    {
      path: '/projects/:projectId/configurations/:configurationId',
      components: {
        app: Configuration,
      },
      beforeEnter: async (to, from, next) => {
        await Promise.all([
          store.dispatch('loadModules'),
          store.dispatch('loadColumnTypes'),
          store.dispatch('projects/loadProject', to.params.projectId),
        ])
        await store.dispatch('configurations/loadConfigurations')
        store.commit(
          'configurations/setActiveConfiguration',
          to.params.configurationId
        )
        store.dispatch("configurations/loadEmptyModulePlacements")
        store.dispatch("configurations/validateFeedIn")
        store.dispatch("configurations/loadRequiredFuseBoxes")
        store.dispatch("configurations/generateBom")
        next()
      },
      children: [
        {
          path: 'type',
          name: 'columnTypesWithConfig',
          component: ColumnTypes,
        },
        {
          path: "electrical-protection",
          name: "electricalProtection",
          component: ElectricalProtection
        },
        {
          path: 'module-placements',
          name: 'modulePlacements',
          component: ModulePlacements,
        },

        {
          path: 'jib-crane',
          name: 'jibCrane',
          component: JibCrane,
        },
        {
          path: 'summary',
          name: 'summary',
          component: Summary,
        },
      ],
    },
    {
      path: '/error',
      name: 'error',
      components: {
        app: ErrorView,
      },
      props: {
        app: (route) => ({
          type: route.query.type,
          attributes: { ...route.query, type: undefined },
        }),
      },
    },
    {
      path: '*',
      name: 'notfound',
      redirect: () => ({
        name: 'error',
        query: { type: 'notfound' },
      }),
    },
  ],
})

export default router

router.beforeEach((to, _from, next) => {
  if (to.name == 'error') return next()
  if (
    cloak.authenticated &&
    cloak.userInfo.roles['base-designer'] &&
    cloak.userInfo.roles['base-designer'].includes('user')
  )
    return next()
  else
    next({
      name: 'error',
      query: { type: 'unauthorized' },
    })
})
